"use client";

// ConfirmDialog renders an inline confirmation modal driven by the
// command-bar invoke flow. Mutation commands that want a quick
// "are you sure?" set confirmation = { title, destructive?, body? }
// on their declaration; the invoker mounts this dialog and runs
// the handler only on confirm.
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { ConfirmationConfig, CommandContext } from "@/lib/commands/types";

export function ConfirmDialog({
  open,
  config,
  ctx,
  onConfirm,
  onClose,
}: {
  open: boolean;
  config: ConfirmationConfig;
  ctx: CommandContext;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const body =
    typeof config.body === "function" ? config.body(ctx) : config.body;
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{config.title}</AlertDialogTitle>
          {body ? <AlertDialogDescription>{body}</AlertDialogDescription> : null}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={
              config.destructive
                ? "bg-destructive text-destructive-foreground hover:bg-destructive/90"
                : undefined
            }
          >
            {config.confirmLabel ?? (config.destructive ? "Confirm" : "OK")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
